var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "d-flex flex-column gr-2",
      attrs: { "data-qa": "payment_terms" },
    },
    [
      _setup.appointmentDataStore.isAnyTelemed
        ? [
            _setup.calendarDataStore.isCalendarDateSelected
              ? [
                  _c(
                    "div",
                    { staticClass: "d-flex align-center text-h6 text--text" },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_setup.t("К оплате", _setup.options)) +
                          "\n        "
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "ml-auto",
                          attrs: { "data-qa": "payment_terms_telemed_price" },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _setup.doctorDataStore.workplacePriceText
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              : _vm._e(),
          ]
        : _setup.doctorDataStore.selectedWorkplace.isFreeWithTreatment
        ? [
            _c("div", { staticClass: "text-h6 text--text" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_setup.t("Условия оплаты", _setup.options)) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "d-flex flex-column gr-4",
                attrs: {
                  "data-qa": "payment_terms_free_appointment_with_treatment",
                },
              },
              [
                _c("div", { staticClass: "d-flex align-center" }, [
                  _c(
                    "div",
                    { staticClass: "text-body-1 text-secondary--text" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_setup.t("Обычная цена", _setup.options)) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "text-body-1 text--text text-decoration-line-through ml-auto",
                      attrs: { "data-qa": "payment_terms_full_price" },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_setup.doctorDataStore.workplacePriceText) +
                          "\n        "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex align-center gc-2" }, [
                  _c(
                    "div",
                    { staticClass: "text-body-1 text-secondary--text" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_setup.t("Акционная цена", _setup.options)) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "ui-icon-tag-discount text-success--text",
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "text-body-1 text-success--text ml-auto",
                      attrs: { "data-qa": "payment_terms_promotional_price" },
                    },
                    [
                      _vm._v(
                        "\n          0 " +
                          _vm._s(_setup.currencySymbol) +
                          "\n        "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "text-body-2 text--text" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _setup.t(
                          "Действует при условии дальнейшего лечения в клинике. При отказе от лечения оплачивается обычная цена консультации. Подробности уточняйте в клинике.",
                          _setup.options
                        )
                      ) +
                      "\n      "
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex align-center text-subtitle-1 text--text" },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_setup.t("Оплата в клинике", _setup.options)) +
                    "\n      "
                ),
                _c(
                  "span",
                  {
                    staticClass: "ml-auto",
                    attrs: { "data-qa": "payment_terms_lpu_price" },
                  },
                  [
                    _vm._v(
                      "\n        0 " +
                        _vm._s(_setup.currencySymbol) +
                        "\n      "
                    ),
                  ]
                ),
              ]
            ),
          ]
        : _c("div", { staticClass: "d-flex align-center text-h6 text--text" }, [
            _vm._v(
              "\n    " +
                _vm._s(_setup.t("Оплата в клинике", _setup.options)) +
                "\n    "
            ),
            _c(
              "span",
              {
                staticClass: "ml-auto",
                attrs: { "data-qa": "payment_terms_lpu_price" },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_setup.doctorDataStore.workplacePriceText) +
                    "\n    "
                ),
              ]
            ),
          ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }